import { I18n } from 'i18n';
import moment from 'moment';

export function makeid(length) {
  let result = '';
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

export const redex = {
  email:
    /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/,
  coordinates:
    /^[-+]?([1-8]?\d(\.\d+)?|90(\.0+)?),\s*[-+]?(180(\.0+)?|((1[0-7]\d)|([1-9]?\d))(\.\d+)?)$/,
  number: /^\d+$/,
};

export function getLanguage({ language }) {
  moment.locale(language || 'es');
  return language || 'es';
}

export const hasPermissionUser = (roles, RoleByAccess, role) => {
  const accessByRole = RoleByAccess.filter((key) => roles.includes(key));
  let permission = true;
  if (accessByRole.length && accessByRole.includes('configuration')) permission = false;
  if (accessByRole.length && accessByRole.includes('full_access')) permission = false;
  return permission;
};

export const hasPermission = (modules, module) => {
  let data = modules.filter(({ name }) => name === module);
  if (!data?.length) return true;
  return false;
};

export const thresholdsColors = {
  green: 'rgba(0, 128, 0, .35)',
  yellow: 'rgba(255, 165, 0, .35)',
  red: 'rgba(	255, 0, 0, .35)',
};

export const days = {
  1: I18n('monday', true),
  2: I18n('tuesday', true),
  3: I18n('wednesday', true),
  4: I18n('thursday', true),
  5: I18n('friday', true),
  6: I18n('saturday', true),
  7: I18n('sunday', true),
};

export const Transmision = [1, 5, 10, 15, 20];

export const ModulesTemetry = [
  'filter_pressure',
  'filter_orp',
  'temperature_and_humidity',
  'gravity_filter',
  'filter_flowrates',
  'filter_tank_levels',
  'motor_pumps',
  'voltage_and_amperage',
];

export const hoursByDay = (time) => {
  let hours = [];
  for (let i = 0; i <= 24; i++) {
    let count = 0;
    while (count < 60 && i !== 24) {
      let hour = `${i < 10 ? 0 : ''}${i}:${count === 0 ? 0 : ''}${count}`;
      hours.push(hour);
      count = count + time;
    }
    if (i === 24) {
      let hour = `24:00`;
      hours.push(hour);
    }
  }
  return hours;
};

export function generateUUID(customerId) {
  let d = new Date().getTime();

  const uuid = 'xxxx-5xxx-yxxx-xxxxxx'.replace(/[xy]/g, (c) => {
    let r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
  });

  return `${uuid}`;
}

export const ThresholdsModule = {
  max_and_min_temperature: {
    0: {
      min: 0,
      max: 4,
      color: 'red',
    },
    1: {
      min: 4,
      max: 8,
      color: 'yellow',
    },
    2: {
      min: 8,
      max: 28,
      color: 'green',
    },
    3: {
      min: 28,
      max: 32,
      color: 'yellow',
    },
    4: {
      min: 32,
      max: 'Infinity',
      color: 'red',
    },
  },
  temperature_and_humidity: {
    0: {
      min: 0,
      max: 4,
      color: 'red',
    },
    1: {
      min: 4,
      max: 8,
      color: 'yellow',
    },
    2: {
      min: 8,
      max: 28,
      color: 'green',
    },
    3: {
      min: 28,
      max: 32,
      color: 'yellow',
    },
    4: {
      min: 32,
      max: 'Infinity',
      color: 'red',
    },
  },
  voltage_and_amperage: {
    0: {
      min: 0,
      max: 4,
      color: 'red',
    },
    1: {
      min: 4,
      max: 8,
      color: 'yellow',
    },
    2: {
      min: 8,
      max: 28,
      color: 'green',
    },
    3: {
      min: 28,
      max: 32,
      color: 'yellow',
    },
    4: {
      min: 32,
      max: 'Infinity',
      color: 'red',
    },
  },
  water_preparation: {
    0: {
      min: 0,
      max: 650,
      color: 'red',
    },
    1: {
      min: 650,
      max: 750,
      color: 'yellow',
    },
    2: {
      min: 750,
      max: 'Infinity',
      color: 'green',
    },
  },
  filter_orp: {
    0: {
      min: 0,
      max: 650,
      color: 'red',
    },
    1: {
      min: 650,
      max: 750,
      color: 'yellow',
    },
    2: {
      min: 750,
      max: 'Infinity',
      color: 'green',
    },
  },
  filter_pressure: {
    0: {
      min: 0,
      max: 10,
      color: 'green',
    },
    1: {
      min: 10,
      max: 12,
      color: 'yellow',
    },
    2: {
      min: 12,
      max: 'Infinity',
      color: 'red',
    },
  },
  gravity_filter: {
    0: {
      min: 0,
      max: 10,
      color: 'green',
    },
    1: {
      min: 10,
      max: 12,
      color: 'yellow',
    },
    2: {
      min: 12,
      max: 'Infinity',
      color: 'red',
    },
  },
  filter_flowrates: {
    0: {
      min: 0,
      max: 4,
      color: 'red',
    },
    1: {
      min: 4,
      max: 8,
      color: 'yellow',
    },
    2: {
      min: 8,
      max: 28,
      color: 'green',
    },
    3: {
      min: 28,
      max: 32,
      color: 'yellow',
    },
    4: {
      min: 32,
      max: 'Infinity',
      color: 'red',
    },
  },
  filter_tank_levels: {
    0: {
      min: 0,
      max: 10,
      color: 'green',
    },
    1: {
      min: 10,
      max: 12,
      color: 'yellow',
    },
    2: {
      min: 12,
      max: 'Infinity',
      color: 'red',
    },
  },
};

export const SettingDataPoint = {
  filter_pressure: {
    pressure: {
      yValuesMax: 30,
      threshold: ThresholdsModule['filter_pressure'],
    },
  },
  filter_orp: {
    orp: {
      yValuesMax: 30,
      threshold: ThresholdsModule['filter_orp'],
    },
  },
  temperature_and_humidity: {
    temperature: {
      yValuesMax: 30,
      threshold: ThresholdsModule['temperature_and_humidity'],
    },
    humidity: {
      yValuesMax: 30,
      threshold: ThresholdsModule['temperature_and_humidity'],
    },
  },
  voltage_and_amperage: {
    voltage: {
      yValuesMax: 30,
      threshold: ThresholdsModule['voltage_and_amperage'],
    },
    amperage: {
      yValuesMax: 30,
      threshold: ThresholdsModule['voltage_and_amperage'],
    },
  },
  gravity_filter: {
    gravity: {
      yValuesMax: 30,
      threshold: ThresholdsModule['gravity_filter'],
    },
  },
  filter_flowrates: {
    flowrates: {
      yValuesMax: 30,
      threshold: ThresholdsModule['filter_flowrates'],
    },
  },
  filter_tank_levels: {
    tank_level: {
      yValuesMax: 30,
      threshold: ThresholdsModule['filter_tank_levels'],
    },
  },
};

export function addThresholdsToSetting(object, configurationsArray) {
  configurationsArray.forEach((config) => {
    const moduleName = config.module;
    const objectSetting = {};

    if (!objectSetting[moduleName]) {
      objectSetting[moduleName] = {
        yValuesMax: object.setting[moduleName].yValuesMax, // Usa yValuesMax del objeto de configuración
        threshold: {},
      };
    }
    config.thresholds.forEach((memo, index) => {
      objectSetting[moduleName].threshold[index] = memo;
    });
    object.setting[moduleName] = objectSetting[moduleName];
  });
  return { ...object };
}
